export const REVIEW_TERM_REPORTS = 'review-term-reports';
export const DENY_TERM_REPORT = 'deny-term-report';
export const COMMENT_TERM_REPORT_SECTION = 'comment-term-report-section';
